@for (option of $options(); track option.value) {
  <wb-checkbox
    [checked]="isChecked(option.value)"
    [disabled]="disabled() || !!option.disabled"
    [readonly]="readonly()"
    [label]="option.label"
    [description]="option.description ?? null"
    [size]="$size()"
    (onToggle)="toggle(option, $event)"
  />
}
